import { Dialog, Transition } from '@headlessui/react';
import { Copy } from 'iconsax-react';
import React, { Fragment, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { getVenueDetails, getVenueDetailsNonSecure } from '../Utils/API';

export default function ShareContentModal({ isOpen, onClose, venueDetails }) {
  
  const [VenuesData, setVenuesData] = useState([]);


  const copyToClipboard = () => {
    const datatocopy = `${VenuesData?.name}\n${VenuesData?.address}\nContact: ${VenuesData?.contact_number}\nDescription: ${VenuesData?.description}\n\nGoogle Maps: ${VenuesData?.google_map_url}`;
    navigator.clipboard.writeText(datatocopy).then(() => {
        toast.success('Venue details copied to the clipboard!');
      }
    ).catch((err) => {
      toast.error('Failed to copy: ', err);
    });
  };

  useEffect(() => {
    const fetchVenueDetails = async () => {
      try {
        if (isOpen) {
          const response = await getVenueDetailsNonSecure(venueDetails?.id)          
          setVenuesData(response?.data)
        }
      } catch (error) {
        console.log('Error:', error)
      }
    }
    fetchVenueDetails();
  }, [isOpen])

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={onClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-50" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-full p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md p-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    Share Content
                  </Dialog.Title>

                  <div className='flex'>
                    <div className="mt-4 space-y-3">
                      <p className="text-sm text-gray-500 font-bold">{VenuesData?.name}</p>
                      <p className="text-sm text-gray-500">
                        {VenuesData?.address}
                      </p>
                      <p className="text-sm text-gray-500">{VenuesData?.contact_number}</p>
                      <p className="text-sm text-gray-500">
                        <span className="font-bold">Description: </span>{VenuesData?.description}
                      </p>
                      <p className="text-sm text-gray-400">
                        {`To view in Google Maps `}
                        <a
                          href={`${VenuesData?.google_map_url ? VenuesData?.google_map_url : "#"}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className='text-blue-600 underline'
                        >
                          Click me
                        </a>
                      </p>
                    </div>
                    <div>
                      <button className='ml-2' onClick={copyToClipboard}>
                        <Copy size="20" color="#000" />
                      </button>
                    </div>
                  </div>

                  <div className="mt-6 text-end">
                    <button
                      type="button"
                      className="px-4 py-2 text-white bg-red-600 rounded hover:bg-red-700"
                      onClick={onClose}
                    >
                      Close
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}
